<tt-page *ngIf="!!settings && !!helpdoc">
    <tt-page-heading style="padding-top: 10px"> {{ helpdoc.heading }} </tt-page-heading>
    <!-- class="col-xs-12 col-md-6 sp-0" -->

    <div class="col-xs-12 p-5">
        <tt-card
            [ngClass]="{
                'flex-1':
                    (settings.selected_view_tab === 'GENERALLY' && settings.general_edit_mode_tab === 'EDIT') ||
                    (settings.selected_view_tab === 'INSTALLATION' && settings.installation_edit_mode_tab === 'EDIT')
            }"
            [ttClass]="
                'flex-column' +
                ((settings.selected_view_tab === 'GENERALLY' && settings.general_edit_mode_tab === 'EDIT') ||
                (settings.selected_view_tab === 'INSTALLATION' && settings.installation_edit_mode_tab === 'EDIT')
                    ? ' height-full'
                    : '')
            "
            style="min-height: fit-content"
        >
            <tt-input *ngIf="helpdoc.webpage > ''" ttLabel="webpage" ttLabelView="top" [ttModel]="helpdoc.webpage" ttReadonly></tt-input>
            <tt-select ttLabel="language" ttLabelView="top" [(ttModel)]="settings.language_id" (ttModelChange)="reloadHelpdoc()" [ttData]="languages"></tt-select>
            <tt-tabs *ngIf="helpdoc.edit_possible === '1' && settings.argtype !== 'helpdoc_keyno_sub'" [(ttSelectedId)]="settings.selected_view_tab">
                <tt-tab ttId="GENERALLY" ttLabel="helpdoc_user"></tt-tab>
                <tt-tab ttId="INSTALLATION" ttLabel="helpdoc_installation"></tt-tab>
            </tt-tabs>

            <ng-container *ngIf="settings.selected_view_tab === 'GENERALLY' || helpdoc.edit_possible === '0'">
                <ng-container *ngTemplateOutlet="generalView; context: { settings: settings, helpdoc: helpdoc }"></ng-container>
            </ng-container>
            <ng-container *ngIf="settings.selected_view_tab === 'INSTALLATION' || settings.argtype === 'helpdoc_keyno_sub'">
                <ng-container *ngTemplateOutlet="installationView; context: { settings: settings, helpdoc: helpdoc }"></ng-container>
            </ng-container>
        </tt-card>
        <!-- class="col-xs-12 col-md-6 sp-0" ttClass="p-0" -->
        <tt-card>
            <tt-list [ttData]="relatedHelpdocs"></tt-list>
        </tt-card>
        <!--  class="col-xs-12 col-md-6 sp-0" -->
        <tt-card>
            <tt-button-goto ttText="helpdoc_helpdocsearch" ttGoto="helpdocsearch"></tt-button-goto>
            <tt-button-goto
                *ngIf="helpdoc.webpage > '' && helpdoc.show_setting === '1'"
                ttText="helpdoc_accessinfo"
                ttGoto="accessinfo"
                [ttGotoParms]="{ argtype: 'webpage', argvalue: helpdoc.webpage }"
            ></tt-button-goto>
        </tt-card>
    </div>
</tt-page>

<ng-template #generalView let-settings="settings" let-helpdoc="helpdoc">
    <tt-tabs *ngIf="helpdoc.db_name === 'mps_dev'" [(ttSelectedId)]="settings.general_edit_mode_tab">
        <tt-tab ttId="VIEW" ttLabel="bg_mode_generally_view"></tt-tab>
        <tt-tab ttId="EDIT" ttLabel="bg_mode_generally_edit"></tt-tab>
    </tt-tabs>

    <ng-container *ngIf="settings.general_edit_mode_tab === 'VIEW' || helpdoc.db_name !== 'mps_dev'">
        <tt-input ttLabel="helpdoctt_headingtext" ttLabelView="top" [ttModel]="helpdoc.helpdoctt_headingtext" ttReadonly></tt-input>
        <tt-editor *ngIf="helpdoc.helpdoctt_bodytext_view !== ''" ttLabel="helpdoctt_bodytext" [ttModel]="helpdoc.helpdoctt_bodytext_view" ttReadonly></tt-editor>
        <tt-editor *ngIf="helpdoc.helpdoc_bodytext !== ''" ttLabel="helpdoc_bodytext" [ttModel]="helpdoc.helpdoc_bodytext" ttReadonly></tt-editor>
        <tt-button-goto
            *ngIf="settings.argtype !== 'helpdoctt_keyno_sub' && settings.argtype !== 'helpdoc_keyno_sub' && helpdoc.db_name === 'mps_dev' && helpdoc.helpdoctt_keyno > '0'"
            ttText="helpdoc_add_new_related"
            ttIcon="far fa-plus"
            ttGoto="helpdoc"
            [ttGotoParms]="{ argtype: 'helpdoctt_keyno_sub', argvalue: helpdoc.helpdoctt_keyno }"
        ></tt-button-goto>
    </ng-container>
    <ng-container *ngIf="settings.general_edit_mode_tab === 'EDIT'">
        <tt-input ttLabel="helpdoctt_headingtext" ttLabelView="top" [(ttModel)]="helpdoc.helpdoctt_headingtext"></tt-input>
        <tt-editor class="flex-1" ttHeight="100%" ttLabel="helpdoctt_bodytext" [(ttModel)]="helpdoc.helpdoctt_bodytext"></tt-editor>
        <tt-button-save ttText="helpdoc_save_generally" (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
    </ng-container>
</ng-template>

<ng-template #installationView let-settings="settings" let-helpdoc="helpdoc">
    <tt-tabs *ngIf="helpdoc.edit_possible === '1'" [(ttSelectedId)]="settings.installation_edit_mode_tab">
        <tt-tab ttId="VIEW" ttLabel="bg_mode_generally_view"></tt-tab>
        <tt-tab ttId="EDIT" ttLabel="bg_mode_generally_edit"></tt-tab>
    </tt-tabs>

    <div [hidden]="settings.installation_edit_mode_tab !== 'VIEW'" style="display: contents">
        <tt-input ttLabel="helpdoc_headingtext" ttLabelView="top" [ttModel]="helpdoc.helpdoc_headingtext" ttReadonly></tt-input>
        <tt-editor *ngIf="!!helpdoc.helpdoc_bodytext" ttLabel="helpdoc_bodytext" [ttModel]="helpdoc.helpdoc_bodytext" ttReadonly></tt-editor>
        <!-- <tt-button-goto
        *ngIf="settings.argtype !== 'helpdoc_keyno_sub' && settings.argtype !== 'helpdoctt_keyno_sub' && helpdoc.helpdoc_keyno > '0'"
        ttText="helpdoc_add_new_related_installation"
            ttIcon="far fa-plus"
            ttGoto="helpdoc"
            [ttGotoParms]="{ argtype: 'helpdoc_keyno_sub', argvalue: helpdoc.helpdoc_keyno }"
        ></tt-button-goto> -->
    </div>
    <div [hidden]="settings.installation_edit_mode_tab !== 'EDIT'" style="display: contents">
        <tt-input ttLabel="helpdoc_headingtext" ttLabelView="top" [(ttModel)]="helpdoc.helpdoc_headingtext"></tt-input>
        <tt-editor class="flex-1" ttHeight="100%" ttLabel="helpdoc_bodytext" [(ttModel)]="helpdoc.helpdoc_bodytext" style="min-height: 500px"></tt-editor>
        <tt-button-save tt-text="helpdoc_save_generally" (ttClick)="save()"></tt-button-save>
    </div>
</ng-template>

<!-- <tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <div ng-if="vm.model.edit.webpage > ''">
            <tt-input class="col-xs-12 sp-0" tt-label="webpage" tt-model="vm.model.edit.webpage" tt-change="vm.model.edit.webpage = $value" tt-readonly="true"></tt-input>
        </div>
        
        <tt-select class="col-xs-12 sp-0" tt-label="language" tt-model="vm.model.setting.language_id" tt-change="vm.onLanguageSelected($value)" tt-data="vm.model.selectListLanguages" tt-data-id="item_id" tt-data-name="item_name"></tt-select>
        <tt-buttons-radio ng-if="vm.model.edit.edit_possible == '1'" tt-model="vm.model.helpdocView.active" tt-buttons="vm.model.helpdocView.buttons"></tt-buttons-radio>
        <tt-buttons-radio ng-if="vm.model.helpdocView.active == 'GENERALLY' && vm.model.edit.db_name == 'mps_dev'" tt-model="vm.model.generallyView.active" tt-buttons="vm.model.generallyView.buttons"></tt-buttons-radio>
        <tt-buttons-radio ng-if="vm.model.helpdocView.active == 'INSTALLATION' && vm.model.edit.edit_possible == '1'" tt-model="vm.model.installationView.active" tt-buttons="vm.model.installationView.buttons"></tt-buttons-radio>

        <div ng-show="vm.model.helpdocView.active == 'GENERALLY'">
            <div ng-show="vm.model.generallyView.active == 'VIEW'">
                <tt-input tt-label="helpdoctt_headingtext" tt-model="vm.model.edit.helpdoctt_headingtext" tt-readonly="true"></tt-input>
                <tt-message ng-if="vm.model.edit.helpdoctt_bodytext_view !== ''" tt-label="helpdoctt_bodytext" tt-model="vm.model.edit.helpdoctt_bodytext_view" tt-is-html="true" tt-translate="true"></tt-message>
                <tt-message ng-if="vm.model.edit.helpdoc_bodytext !== ''" tt-label="helpdoc_bodytext" tt-model="vm.model.edit.helpdoc_bodytext" tt-is-html="true" tt-translate="true"></tt-message>
                <tt-button-goto ng-if="vm.model.argtype !== 'helpdoctt_keyno_sub' && vm.model.edit.db_name == 'mps_dev'" tt-text="helpdoc_add_new_related" tt-goto-func="vm.addNewRelatedHelpDoc()" tt-icon="fas fa-plus" tt-text-align="left"></tt-button-goto>
            </div>
            <div ng-show="vm.model.generallyView.active == 'EDIT'">
                <tt-input class="col-xs-12 sp-0" tt-label="helpdoctt_headingtext" tt-model="vm.model.edit.helpdoctt_headingtext" tt-change="vm.model.edit.helpdoctt_headingtext = $value" tt-placeholder=""></tt-input>
                <tt-label tt-label="helpdoc_headingtext" tt-model="vm.model.edit.helpdoc_headingtext" tt-change="vm.model.edit.helpdoc_headingtext = $value"></tt-label>
                <tt-text-editor tt-label="helpdoctt_bodytext" tt-model="vm.model.edit.helpdoctt_bodytext" tt-change="vm.model.edit.helpdoctt_bodytext = $value" tt-ready="vm.model.editorReady" tt-style="vm.style.editor"></tt-text-editor>
                <tt-button-save tt-text="helpdoc_save_generally" tt-click="vm.saveHelpDoc()" tt-locked="vm.model.editorReady === false"></tt-button-save>
            </div>
        </div>

        <div ng-show="vm.model.helpdocView.active == 'INSTALLATION'">
            <div ng-show="vm.model.installationView.active == 'VIEW'">
                <tt-input tt-label="helpdoc_headingtext" tt-model="vm.model.edit.helpdoc_headingtext" tt-readonly="true"></tt-input>
                <tt-message ng-if="vm.model.edit.helpdoc_bodytext !== ''" tt-label="helpdoc_bodytext" tt-model="vm.model.edit.helpdoc_bodytext" tt-is-html="true" tt-translate="true"></tt-message>
            </div>
            <div ng-show="vm.model.installationView.active == 'EDIT'">
                <tt-input class="col-xs-12 sp-0" tt-label="helpdoc_headingtext" tt-model="vm.model.edit.helpdoc_headingtext" tt-change="vm.model.edit.helpdoc_headingtext = $value" tt-placeholder=""></tt-input>
                <tt-label tt-label="helpdoc_headingtext" tt-model="vm.model.edit.helpdoc_headingtext" tt-change="vm.model.edit.helpdoc_headingtext = $value"></tt-label>
                <tt-text-editor tt-label="helpdoc_bodytext" tt-model="vm.model.edit.helpdoc_bodytext" tt-change="vm.model.edit.helpdoc_bodytext = $value" tt-ready="vm.model.editorReady" tt-style="vm.style.editor"></tt-text-editor>
                <tt-button-save tt-text="helpdoc_save_generally" tt-click="vm.saveHelpDoc()" tt-locked="vm.model.editorReady === false"></tt-button-save>
            </div>
        </div>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListRelatedDocs" badge="" ltype="" design-var="s12t0"></tt-list>

    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button-goto class="col-xs-12 sp-0" tt-text="helpdoc_helpdocsearch" tt-goto="helpdocsearch" tt-goto-parms="" tt-text-align="left"></tt-button-goto>
        <tt-button-goto ng-if="vm.model.edit.webpage > '' && vm.model.edit.show_setting === '1'" class="col-xs-12 sp-0" tt-text="helpdoc_accessinfo" tt-goto="accessinfo" tt-goto-parms="{ argtype: 'webpage', argvalue: vm.model.edit.webpage }" tt-text-align="left"></tt-button-goto>
    </tt-card>
</tt-page> -->
